import { render, staticRenderFns } from "./FormForgotPassword.vue?vue&type=template&id=b452ed04&scoped=true"
import script from "./FormForgotPassword.vue?vue&type=script&lang=js"
export * from "./FormForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b452ed04",
  null
  
)

export default component.exports